import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseSupportApiUrl = 'api/support';
const baseRestaurantApiUrl = 'api/restaurant';
const baseMarketerApiUrl = 'api/marketer';
const baseApiUrl = 'api';

export default class BillingsService {
  public getBillings(orderDates: { orderDateStart: Date; orderDateEnd: Date }, req?: any): Promise<any> {
    return this.getBilling(`${baseSupportApiUrl}/billings?${buildPaginationQueryOpts(req)}`, orderDates);
  }

  public getBillingsForRestaurant(orderDates: { orderDateStart: Date; orderDateEnd: Date }, restaurantId: number, req?: any): Promise<any> {
    return this.getBilling(`${baseApiUrl}/restaurant/billings/${restaurantId}?${buildPaginationQueryOpts(req)}`, orderDates);
  }

  public getBillingsForMarketer(orderDates: { orderDateStart: Date; orderDateEnd: Date }, marketerId: number, req?: any): Promise<any> {
    return this.getBilling(`${baseApiUrl}/marketer/billings/${marketerId}?${buildPaginationQueryOpts(req)}`, orderDates);
  }

  public getBillingsDataForRestaurant(restaurantId: number): Promise<any> {
    return this.getBilling(`${baseApiUrl}/restaurant/billingsdata/${restaurantId}`);
  }

  public getExcelBillingsDataForRestaurant(restaurantId: number, orderDates: { orderDateStart: Date; orderDateEnd: Date }) {
    return this.prepareAndDownloadReport(`${baseApiUrl}/restaurant/billings/excel-export/${restaurantId}`, orderDates);
  }

  public exportBillings(orderDates: { orderDateStart: Date; orderDateEnd: Date }): Promise<any> {
    return this.prepareAndDownloadReport(`${baseSupportApiUrl}/billings/export`, orderDates);
  }

  public exportCsvBillingsForRestaurant(orderDates: { orderDateStart: Date; orderDateEnd: Date }, id: number): Promise<any> {
    return this.prepareAndDownloadReport(`${baseRestaurantApiUrl}/billings/csv-export/${id}`, orderDates);
  }

  public exportExcelBillingsForRestaurant(orderDates: { orderDateStart: Date; orderDateEnd: Date }, id: number): any {
    return this.prepareAndDownloadReport(`${baseRestaurantApiUrl}/billings/excel-export/${id}`, orderDates);
  }

  public exportBillingsForMarketer(orderDates: { orderDateStart: Date; orderDateEnd: Date }, id: number): Promise<any> {
    return this.prepareAndDownloadReport(`${baseMarketerApiUrl}/billings/export/${id}`, orderDates);
  }

  public getIncomes(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseSupportApiUrl}/incomes)`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  private getBilling(url: string, orderDates?: { orderDateStart: Date; orderDateEnd: Date }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, orderDates)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  private prepareAndDownloadReport(url: string, orderDates?: { orderDateStart: Date; orderDateEnd: Date }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, orderDates, { responseType: 'blob' })
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.setAttribute('download', res.headers['content-disposition'].split('filename=')[1]);
          link.href = url;
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
